import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";
import { v4 as uuidv4 } from "uuid";

function ArticulosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_VARIANTES_ARTICULOS = process.env.REACT_APP_URL_VARIANTES_ARTICULOS;

  const [codigo, setCodigo] = useState("");
  const [codigoSAT, setCodigoSAT] = useState("");
  const [clave, setClave] = useState("NA");
  const [nombre, setNombre] = useState("");
  const [modelo, setModelo] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [costoUSD, setCostoUSD] = useState("");
  const [WUPC, setWUPC] = useState("NA");
  const [costoMX, setCostoMX] = useState("");
  const [venta, setVenta] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [EAN, setEAN] = useState("NA");
  const [SKU, setSKU] = useState("NA");
  const [MLM, setMLM] = useState("NA");
  const [ASIN, setASIN] = useState("NA");
  const [linkML, setLinkML] = useState("NA");
  const [linkShein, setLinkShein] = useState("NA");
  const [linkAmazon, setLinkAmazon] = useState("NA");
  const [linkCoppel, setLinkCoppel] = useState("NA");
  const [linkLiverpool, setLinkLiverpool] = useState("NA");
  const [linkWalmart, setLinkWalmart] = useState("NA");
  const [linkElektra, setLinkElektra] = useState("NA");

  const [imagenes, setImagenes] = useState("");
  const [especiales, setEspeciales] = useState("No");
  const [cargadoML, setCargadoML] = useState("Si");
  const [cargadoShein, setCargadoShein] = useState("No");
  const [cargadoAmazon, setCargadoAmazon] = useState("No");
  const [cargadoCoppel, setCargadoCoppel] = useState("No");
  const [cargadoWalmart, setCargadoWalmart] = useState("No");
  const [cargadoLiverpool, setCargadoLiverpool] = useState("No");
  const [cargadoElektra, setCargadoElektra] = useState("No");

  const [largoProducto, setLargoProducto] = useState(0);
  const [anchoProducto, setAnchoProducto] = useState(0);
  const [altoProducto, setAltoProducto] = useState(0);
  const [pesoProducto, setPesoProducto] = useState(0);
  const [largoEmpaque, setLargoEmpaque] = useState(0);
  const [anchoEmpaque, setAnchoEmpaque] = useState(0);
  const [altoEmpaque, setAltoEmpaque] = useState(0);
  const [pesoEmpaque, setPesoEmpaque] = useState(0);
  const [largoMaster, setLargoMaster] = useState(0);
  const [anchoMaster, setAnchoMaster] = useState(0);
  const [altoMaster, setAltoMaster] = useState(0);
  const [pesoMaster, setPesoMaster] = useState(0);
  const [stockMinimo, setStockMinimo] = useState(0);
  const [stockMaximo, setStockMaximo] = useState(0);
  const [indiceRotacion, setIndiceRotacion] = useState(0);
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [lista1, setLista1] = useState(0);
  const [lista2, setLista2] = useState(0);
  const [lista3, setLista3] = useState(0);
  const [lista4, setLista4] = useState(0);
  const [lista1Bruto, setLista1Bruto] = useState(0);
  const [lista2Bruto, setLista2Bruto] = useState(0);
  const [lista3Bruto, setLista3Bruto] = useState(0);
  const [lista4Bruto, setLista4Bruto] = useState(0);
  const [comision, setComision] = useState(0);
  const [otrosCostos, setOtrosCostos] = useState(0);

  const [variantesFields, setVariantesFields] = useState([]);

  // Helpers para el TagInput de Variantes
  function addTag(vfId, field, value) {
    const trimmed = value.trim();
    if (!trimmed) return;
    setVariantesFields((prev) =>
      prev.map((v) =>
        v.id === vfId ? { ...v, [field]: [...v[field], trimmed] } : v
      )
    );
  }
  function removeTag(vfId, field, index) {
    setVariantesFields((prev) =>
      prev.map((v) =>
        v.id === vfId
          ? { ...v, [field]: v[field].filter((_, i) => i !== index) }
          : v
      )
    );
  }

  const [validaBoton, setValidaBoton] = useState(true);

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios
        .post(
          URL_ARTICULOS,
          {
            codigo,
            codigoSAT,
            clave,
            nombre,
            modelo,
            piezasPorCaja,
            costoUSD,
            WUPC,
            costoMX,
            venta,
            observaciones,
            EAN,
            SKU,
            MLM,
            ASIN,
            ASINAntiguo: ASIN,
            imagenes,
            linkML,
            linkShein,
            linkAmazon,
            linkCoppel,
            linkWalmart,
            linkLiverpool,
            linkElektra,
            cargadoML,
            cargadoShein,
            cargadoAmazon,
            cargadoCoppel,
            cargadoWalmart,
            cargadoLiverpool,
            cargadoElektra,
            largoProducto,
            anchoProducto,
            altoProducto,
            pesoProducto,
            largoEmpaque,
            anchoEmpaque,
            altoEmpaque,
            pesoEmpaque,
            largoMaster,
            anchoMaster,
            altoMaster,
            pesoMaster,
            stockMinimo,
            stockMaximo,
            indiceRotacion,
            lineas: selectedLinea,
            marcas: selectedMarca,
            familias: selectedFamilia,
            proveedores: selectedProveedor,
            especiales,
            lista1,
            lista2,
            lista3,
            lista4,
            lista1Bruto,
            lista2Bruto,
            lista3Bruto,
            lista4Bruto,
            comision,
            otrosCostos,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )

        .then((data) => {
          axios
            .post(
              URL_INVENTARIOS,
              {
                articulos: data.data._id,
                areas: AREAS_CEDIS,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )

            .then(() => {
              const variantesPromises = variantesFields.map((v) =>
                axios.post(
                  URL_VARIANTES_ARTICULOS,
                  {
                    articulos: data.data._id,
                    nombre: v.nombre,
                    ASIN: v.ASIN,
                    WUPC: v.WUPC,
                    MLM: v.MLM,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
              );
              Promise.all(variantesPromises).then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Crear Modelo",
                    detalle: `${nombre} ${codigo}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  const sec = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container">
          <h3 align="center">Nuevo Modelo</h3>
          <Form onSubmit={saveArticulos}>
            <input type="hidden" value={clave} />

            {/* ── 1. Identificadores ── */}
            <div style={block}>
              <p style={sec}>🏷 Identificadores</p>
              <Row>
                <Col md={3}><Label>Codigo de Origen</Label>
                  <Input type="text" placeholder="Codigo" value={codigo} required onChange={e => setCodigo(e.target.value)} /></Col>
                <Col md={3}><Label>Codigo SAT</Label>
                  <Input type="text" placeholder="CodigoSAT" value={codigoSAT} required onChange={e => setCodigoSAT(e.target.value)} /></Col>
                <Col md={3}><Label>UPC</Label>
                  <Input type="text" placeholder="UPC" value={EAN} onChange={e => setEAN(e.target.value)} /></Col>
                <Col md={3}><Label>Parent (SKU)</Label>
                  <Input type="text" placeholder="Parent" value={SKU} onChange={e => setSKU(e.target.value)} /></Col>
              </Row>
              <Row className="mt-2">
                <Col md={3}><Label>MLM</Label>
                  <Input type="text" placeholder="MLM" value={MLM} onChange={e => setMLM(e.target.value)} /></Col>
                <Col md={4}><Label>Nombre</Label>
                  <Input type="text" placeholder="Nombre del producto" value={nombre} required onChange={e => setNombre(e.target.value)} /></Col>
                <Col md={3}><Label>Variante / Modelo</Label>
                  <Input type="text" placeholder="Ej: Rojo Talla M" value={modelo} onChange={e => setModelo(e.target.value)} /></Col>
                <Col md={2}><Label>Pzas x Caja</Label>
                  <Input type="number" min="0" step="any" value={piezasPorCaja} required onChange={e => setPiezasPorCaja(e.target.value)} /></Col>
              </Row>
              <Row className="mt-2">
                <Col md={3}><Label>ASIN</Label>
                  <Input type="text" placeholder="ASIN" value={ASIN} onChange={e => setASIN(e.target.value)} /></Col>
                <Col md={3}><Label>WUPC (Walmart UPC)</Label>
                  <Input type="text" placeholder="WUPC" value={WUPC} onChange={e => setWUPC(e.target.value)} /></Col>
                <Col md={3}><Label>Imágenes</Label>
                  <Input type="select" value={imagenes} required onChange={e => setImagenes(e.target.value)}>
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input></Col>
              </Row>
            </div>

            {/* ── 2. Clasificación ── */}
            <div style={block}>
              <p style={sec}>📁 Clasificación</p>
              <Row>
                <Col md={3}><Label>Línea</Label>
                  <Input type="select" value={selectedLinea} required onChange={e => setSelectedLinea(e.target.value)}>
                    <option value="0">Selecciona</option>
                    {lineas.sort((a,b) => a.name > b.name ? 1:-1).map(a => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input></Col>
                <Col md={3}><Label>Marca</Label>
                  <Input type="select" value={selectedMarca} required onChange={e => setSelectedMarca(e.target.value)}>
                    <option value="0">Selecciona</option>
                    {marcas.sort((a,b) => a.name > b.name ? 1:-1).map(a => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input></Col>
                <Col md={3}><Label>Categoría</Label>
                  <Input type="select" value={selectedFamilia} required onChange={e => setSelectedFamilia(e.target.value)}>
                    <option value="0">Selecciona</option>
                    {familias.sort((a,b) => a.name > b.name ? 1:-1).map(a => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input></Col>
                <Col md={3}><Label>Proveedor</Label>
                  <Input type="select" value={selectedProveedor} required onChange={e => setSelectedProveedor(e.target.value)}>
                    <option value="0">Selecciona</option>
                    {proveedores.sort((a,b) => a.nombre_comercial > b.nombre_comercial ? 1:-1).map(a => <option key={a._id} value={a._id}>{a.nombre_comercial}</option>)}
                  </Input></Col>
              </Row>
            </div>

            {/* ── 3. Costos y Precios ── */}
            <div style={block}>
              <p style={sec}>💰 Costos y Precios</p>
              <Row>
                <Col md={2}><Label>FOB USD</Label>
                  <Input type="number" placeholder="0" value={costoUSD} required onChange={e => setCostoUSD(e.target.value)} /></Col>
                <Col md={2}><Label>Costo MX</Label>
                  <Input type="number" placeholder="0" value={costoMX} required onChange={e => setCostoMX(e.target.value)} /></Col>
                <Col md={2}><Label>Precio Venta</Label>
                  <Input type="number" placeholder="0" value={venta} required onChange={e => setVenta(e.target.value)} /></Col>
                <Col md={2}><Label>Stock Mín.</Label>
                  <Input type="number" min="0" value={stockMinimo} onChange={e => setStockMinimo(e.target.value)} /></Col>
                <Col md={2}><Label>Stock Máx.</Label>
                  <Input type="number" min="0" value={stockMaximo} onChange={e => setStockMaximo(e.target.value)} /></Col>
              </Row>
              <Row className="mt-3">
                <Col md={12}><span style={{ fontSize:"0.78rem", fontWeight:600, color:"#475569", textTransform:"uppercase", letterSpacing:"0.05em" }}>Precios Neto &nbsp;</span>
                  <span style={{ fontSize:"0.75rem", color:"#94a3b8" }}>(Lista 1 · Lista 2 · Lista 3 · Lista 4)</span></Col>
              </Row>
              <Row className="mt-1">
                {[{v:lista1,s:setLista1},{v:lista2,s:setLista2},{v:lista3,s:setLista3},{v:lista4,s:setLista4}].map(({v,s},i) => (
                  <Col md={3} key={i}><Label style={{fontSize:"0.8rem"}}>Lista {i+1}</Label>
                    <Input type="number" min="0" step="any" value={v} required onChange={e => s(e.target.value)} /></Col>
                ))}
              </Row>
              <Row className="mt-2">
                <Col md={12}><span style={{ fontSize:"0.78rem", fontWeight:600, color:"#475569", textTransform:"uppercase", letterSpacing:"0.05em" }}>Precios Bruto</span></Col>
              </Row>
              <Row className="mt-1">
                {[{v:lista1Bruto,s:setLista1Bruto},{v:lista2Bruto,s:setLista2Bruto},{v:lista3Bruto,s:setLista3Bruto},{v:lista4Bruto,s:setLista4Bruto}].map(({v,s},i) => (
                  <Col md={3} key={i}><Label style={{fontSize:"0.8rem"}}>Lista {i+1}</Label>
                    <Input type="number" min="0" step="any" value={v} required onChange={e => s(e.target.value)} /></Col>
                ))}
              </Row>
            </div>

            {/* ── 4. Medidas ── */}
            <div style={block}>
              <p style={sec}>📐 Medidas</p>
              {[
                { label: "Producto", fields: [{v:largoProducto,s:setLargoProducto},{v:anchoProducto,s:setAnchoProducto},{v:altoProducto,s:setAltoProducto},{v:pesoProducto,s:setPesoProducto}] },
                { label: "Empaque",  fields: [{v:largoEmpaque,s:setLargoEmpaque},{v:anchoEmpaque,s:setAnchoEmpaque},{v:altoEmpaque,s:setAltoEmpaque},{v:pesoEmpaque,s:setPesoEmpaque}] },
                { label: "Master",   fields: [{v:largoMaster,s:setLargoMaster},{v:anchoMaster,s:setAnchoMaster},{v:altoMaster,s:setAltoMaster},{v:pesoMaster,s:setPesoMaster}] },
              ].map(({ label, fields }) => (
                <div key={label} style={{ marginBottom: 8 }}>
                  <span style={{ fontSize:"0.78rem", fontWeight:600, color:"#64748b", textTransform:"uppercase" }}>{label}</span>
                  <Row>
                    {["Largo","Ancho","Alto","Peso"].map((dim, i) => (
                      <Col md={3} key={dim}><Label style={{fontSize:"0.8rem"}}>{dim}</Label>
                        <Input type="number" min="0" step="any" value={fields[i].v} onChange={e => fields[i].s(e.target.value)} /></Col>
                    ))}
                  </Row>
                </div>
              ))}
            </div>
            <br />
            <h4>Variantes</h4>
            <Button
              type="button"
              size="sm"
              color="info"
              onClick={() =>
                setVariantesFields([
                  ...variantesFields,
                  { id: uuidv4(), nombre: "", ASIN: [], WUPC: [], MLM: [] },
                ])
              }
            >
              <i className="fas fa-plus"></i> Agregar Variante
            </Button>
            {variantesFields.length > 0 && (
              <Table borderless size="sm" style={{ marginTop: "8px" }}>
                <thead>
                  <tr>
                    <th style={{ minWidth: 130 }}>Nombre</th>
                    <th>ASIN</th>
                    <th>WUPC</th>
                    <th>MLM</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {variantesFields.map((vf) => (
                    <tr key={vf.id} style={{ verticalAlign: "top" }}>
                      <td>
                        <Input
                          type="text"
                          placeholder="Variante"
                          value={vf.nombre}
                          onChange={(e) =>
                            setVariantesFields(
                              variantesFields.map((v) =>
                                v.id === vf.id ? { ...v, nombre: e.target.value } : v
                              )
                            )
                          }
                        />
                      </td>
                      {["ASIN", "WUPC", "MLM"].map((field) => (
                        <td key={field} style={{ minWidth: 160 }}>
                          <TagCellInput
                            values={vf[field]}
                            placeholder={field}
                            onAdd={(val) => addTag(vf.id, field, val)}
                            onRemove={(i) => removeTag(vf.id, field, i)}
                          />
                        </td>
                      ))}
                      <td style={{ paddingTop: 6 }}>
                        <Button
                          type="button"
                          size="sm"
                          color="danger"
                          onClick={() =>
                            setVariantesFields(variantesFields.filter((v) => v.id !== vf.id))
                          }
                        >
                          <i className="fas fa-minus"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoArticulos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

// ── TagCellInput: chips con Enter/coma para agregar, × para quitar ──
function TagCellInput({ values, placeholder, onAdd, onRemove }) {
  const [inputVal, setInputVal] = React.useState("");

  function handleKey(e) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      if (inputVal.trim()) {
        onAdd(inputVal.trim());
        setInputVal("");
      }
    }
  }

  function handleBlur() {
    if (inputVal.trim()) {
      onAdd(inputVal.trim());
      setInputVal("");
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 4,
        alignItems: "center",
        border: "1px solid #ced4da",
        borderRadius: 4,
        padding: "4px 6px",
        minHeight: 34,
        cursor: "text",
      }}
    >
      {values.map((v, i) => (
        <span
          key={i}
          style={{
            background: "#dbeafe",
            color: "#1e3a8a",
            padding: "1px 8px 1px 8px",
            borderRadius: 12,
            fontSize: "0.74rem",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 4,
            whiteSpace: "nowrap",
          }}
        >
          {v}
          <button
            type="button"
            onClick={() => onRemove(i)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#1e3a8a",
              padding: 0,
              lineHeight: 1,
              fontSize: "0.85rem",
              fontWeight: 700,
            }}
          >
            ×
          </button>
        </span>
      ))}
      <input
        type="text"
        placeholder={values.length === 0 ? `+ ${placeholder}` : "+"}
        value={inputVal}
        onChange={(e) => setInputVal(e.target.value)}
        onKeyDown={handleKey}
        onBlur={handleBlur}
        style={{
          border: "none",
          outline: "none",
          fontSize: "0.78rem",
          minWidth: 60,
          flex: 1,
          background: "transparent",
        }}
      />
    </div>
  );
}

export default ArticulosCreate;
